import { Component, input, output } from '@angular/core';
import { MatChipListboxChange, MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { Item } from '../../form/select-field/select-field.component';

@Component({
  selector: 'siat-calendar-subheader',
  standalone: true,
  imports: [MatChipsModule, MatIconModule],
  templateUrl: './calendar-subheader.component.html',
})
export class CalendarSubheaderComponent {
  /**
   * The machinery list.
   */
  readonly machineryList = input<Item[]>([]);

  /**
   * The selected machinery's id.
   */
  readonly selectedId = input<string | number | null>(null);

  /**
   * Emit the selected machinery.
   */
  readonly machinerySelected = output<Item>();

  /**
   * On selection change, emit the selected machinery.
   */
  protected onSelectionChange(change: MatChipListboxChange): void {
    const selected = change.value as Item | undefined;
    if (!selected) return;
    this.machinerySelected.emit(selected);
  }
}
